var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("e-sign-package.messages.belowIsTheList")) + ":"),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("v-client-table", {
          ref: "table",
          staticClass: "vue-custom-table no-pagination",
          attrs: {
            data: _vm.clientApplicationRequestValues,
            columns: _vm.table.columns,
            options: _vm.table.options,
            name: "selectFilesTable",
          },
          scopedSlots: _vm._u([
            {
              key: "status",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "h5",
                    {
                      staticClass: "mb-0 font-sm text-light-gray bold d-inline",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ml-1 badge",
                          class: _vm.getBadgeType(row.status),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("removeHyphens")(row.status)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "subject",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "h5",
                    {
                      staticClass: "mb-0 font-sm text-light-gray bold d-inline",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(row.metadata.subject) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "date",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center flex-row" },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDatepickerDate")(row.createdAt)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showReminder(row.status) &&
                      !_vm.reminding[row.clientApplicationRequestId]
                        ? _c(
                            "inline-prompt",
                            {
                              staticClass: "d-inline-block e-sign-reminder",
                              attrs: {
                                "accept-text-class": "text-warning bg-warning",
                                "confirmation-text":
                                  "i18n|e-sign-package.messages.sendAReminder",
                              },
                              on: {
                                accept: function ($event) {
                                  return _vm.sendReminder(row)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "preConfirmationContent",
                                    fn: function () {
                                      return [_vm._t("delete-confirmation")]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", { staticClass: "clickable ml-2" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "fa-stack fa-lg",
                                    staticStyle: {
                                      "font-size": "1.2rem !important",
                                    },
                                  },
                                  [
                                    _c("em", {
                                      staticClass:
                                        "fa fa-envelope-o text-grey fa-stack-2x",
                                      staticStyle: {
                                        top: "8px",
                                        "font-size": "1em",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("em", {
                                      staticClass:
                                        "fa fa-bell fa-stack-1x text-warning",
                                      staticStyle: {
                                        "font-size": "0.7em",
                                        left: "9px",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm.reminding[row.clientApplicationRequestId]
                        ? _c("inline-loader", { staticClass: "ml-4" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "d-flex justify-content-end" }, [
                    _c(
                      "div",
                      { staticClass: "btn-group pl-1 pr-2 d-none d-xl-block" },
                      [
                        _vm.showCancel(row.status)
                          ? _c(
                              "inline-prompt",
                              {
                                attrs: {
                                  "confirmation-text": _vm.$t(
                                    "e-sign-package.messages.confirmCancel"
                                  ),
                                },
                                on: {
                                  accept: function ($event) {
                                    return _vm.updateStatus(row)
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-danger btn-xs font-small",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("global.words.cancel")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-group pl-1 pr-2 d-none d-xl-block" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-primary btn btn-xs font-small",
                            on: {
                              click: function ($event) {
                                return _vm.showDetails(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.actions.viewDetails")) +
                                "\n              "
                            ),
                            _c("em", { staticClass: "fa fa-caret-down ml-1" }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropleft d-flex d-xl-none" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "grey-text text-darken-4 clickable d-xl-none",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _c("em", { staticClass: "material-icons" }, [
                            _vm._v("more_vert"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-item clickable wide px-4",
                            on: {
                              click: function ($event) {
                                return _vm.showDetails(row)
                              },
                            },
                          },
                          [
                            _c("button", { staticClass: "btn btn-white" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("global.actions.viewDetails")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showCancel(row.status)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-item clickable wide px-4",
                                on: {
                                  click: function ($event) {
                                    return _vm.updateStatus(row)
                                  },
                                },
                              },
                              [
                                _c("button", { staticClass: "btn btn-white" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("global.words.cancel")) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "child_row",
              fn: function (props) {
                return [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(
                      props.row.metadata.signers,
                      function (signer, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-12 mb-2" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.words.status")) + ": "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-0 mb-0 badge",
                                    class: _vm.getBadgeType(signer.status),
                                    staticStyle: { "font-size": "0.5rem" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(signer.status) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                signer.firstViewedAt
                                  ? _c("icon", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.top",
                                          value: _vm.$t(
                                            "documents.initiallyViewed",
                                            {
                                              date: _vm.$options.filters.momentLocal(
                                                signer.firstViewedAt,
                                                "MMM DD, YYYY"
                                              ),
                                              time: _vm.$options.filters.momentLocal(
                                                signer.firstViewedAt,
                                                "HH:mm"
                                              ),
                                            }
                                          ),
                                          expression:
                                            "\n                  $t('documents.initiallyViewed', {\n                    date: $options.filters.momentLocal(\n                      signer.firstViewedAt,\n                      'MMM DD, YYYY'\n                    ),\n                    time: $options.filters.momentLocal(\n                      signer.firstViewedAt,\n                      'HH:mm'\n                    )\n                  })\n                ",
                                          modifiers: { top: true },
                                        },
                                      ],
                                      attrs: {
                                        name: "eye",
                                        "icon-class": "m-1 text-primary",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("e-sign-package.signerName")
                                    ) + ":\n              "
                                  ),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(signer.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.$tc("global.words.email", 1)
                                      )
                                    ) + ":\n              "
                                  ),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(signer.email) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }